export {
  add,
  getSessionId,
  getDeviceId,
  identify,
  Identify,
  init,
  revenue,
  Revenue,
  setDeviceId,
  setOptOut,
  setSessionId,
  setUserId,
  track,
  Types,
} from '@amplitude/analytics-browser';
